import { ClassifiedBlockOperatoryBlock } from '../../rest/types/Classified'

export function BlockShareOperatingTheatreTransformer({
  block,
  t,
}: {
  block: ClassifiedBlockOperatoryBlock
  t: any
}) {
  return {
    ...(block?.speciality?.name && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.speciality?.name
            ? [
                {
                  title: t('ads_types_speciality_title'),
                  text: block?.speciality?.name,
                },
              ]
            : []),
        ],
      },
    }),
    adsDetailsColumn: {
      items: [
        ...(block?.establishmentName
          ? [
              {
                label: t('ads_details_establishment_name'),
                value: block?.establishmentName,
              },
            ]
          : []),
        ...(block?.group
          ? [
              {
                label: t('ads_details_group'),
                value: block?.group,
              },
            ]
          : []),

        {
          label: t('ads_details_operatory_help_provided'),
          value: block?.operatoryHelpProvided
            ? t('form_boolean_value_true')
            : t('form_boolean_value_false'),
        },

        {
          label: t('ads_details_tools_provided'),
          value: block?.toolsProvided
            ? t('form_boolean_value_true')
            : t('form_boolean_value_false'),
        },

        ...(block?.treatmentType?.length
          ? [
              {
                label: t('ads_details_treatment_type'),
                values: block?.treatmentType?.map((item) =>
                  t(`ads_details_treatment_type_${item}`)
                ),
              },
            ]
          : []),

        {
          label: t('ads_details_establishment_approved'),
          value: block?.establishmentApproved
            ? t('form_boolean_value_true')
            : t('form_boolean_value_false'),
        },
      ],
    },
    adsDetails: {
      withColumn: false,
      items: [
        ...(block?.description
          ? [
              {
                label: t('ads_details_technical_platform_title'),
                value: block?.description,
              },
            ]
          : []),
        ...(block?.availabilities
          ? [
              {
                label: t('ads_details_availabilities_title'),
                value: block?.availabilities,
              },
            ]
          : []),
      ],
    },
  }
}
